import { clsx } from 'clsx';
import { Tooltip } from '@/components/ui/Tooltip';

interface Props {
  score: number;
  showLabel?: boolean;
}

export function PartnershipHealthBar({ score, showLabel = true }: Props) {
  const color = score >= 80 ? 'bg-emerald-500' : score >= 60 ? 'bg-amber-500' : 'bg-red-500';
  const textColor = score >= 80 ? 'text-emerald-400' : score >= 60 ? 'text-amber-400' : 'text-red-400';

  return (
    <Tooltip content={`Health Score: ${score}/100`}>
      <div className="flex items-center gap-2">
        <div className="w-16 h-1.5 bg-surface-700 rounded-full overflow-hidden">
          <div className={clsx('h-full rounded-full transition-all', color)} style={{ width: `${score}%` }} />
        </div>
        {showLabel && <span className={clsx('text-xs font-medium', textColor)}>{score}</span>}
      </div>
    </Tooltip>
  );
}
